import HomeAanmelding from '@/components/views/CW/Aanmelding/HomeAanmelding';
import userConsentAanmelding from '@/components/views/CW/Aanmelding/userConsentAanmelding';
import signupInformation from '@/components/views/CW/Aanmelding/signupInformation';
import signupVerification from '@/components/views/CW/Aanmelding/signupVerification';
import signupSuccess from '@/components/views/CW/Aanmelding/signupSuccess';

const aanMeldingPages = [
    {
        path: '/HomeAanmelding',
        component: HomeAanmelding,
        name: 'HomeAanmelding'
    },
    {
        path: '/signupConsent',
        component: userConsentAanmelding,
        name: 'userConsentAanmelding'
    },
    {
        path: '/signupInformation',
        component: signupInformation,
        name: 'signupInformation'
    },
    {
        path: '/signupVerification',
        component: signupVerification,
        name: 'signupVerification'
    },
    {
        path: '/signupSuccess',
        component: signupSuccess,
        name: 'signupSuccess'
    }
]

export default aanMeldingPages
